var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1V5C6 6.65234 7.34766 8 9 8H11V14.7188C11 17.7266 12.4961 20.5508 15 22.2188L19.1875 25L15 27.7812C12.4961 29.4492 11 32.2734 11 35.2812V42H9C7.34766 42 6 43.3477 6 45V49H44V45C44 43.3477 42.6523 42 41 42H39V35.2812C39 32.2734 37.5039 29.4492 35 27.7812L30.8125 25L35 22.2188C37.5039 20.5508 39 17.7266 39 14.7188V8H41C42.6523 8 44 6.65234 44 5V1H6ZM13 8H37V14.7188C37 17.0586 35.8242 19.2344 33.875 20.5312L28.4375 24.1562L27.1875 25L28.4375 25.8438L33.875 29.4688C35.8242 30.7695 37 32.9414 37 35.2812V42H13V35.2812C13 32.9414 14.1758 30.7695 16.125 29.4688L21.5625 25.8438L22.8125 25L21.5625 24.1562L16.125 20.5312C14.1758 19.2344 13 17.0586 13 14.7188V8ZM17 15C17 20.0898 25 22 25 22C25 22 33 19.9844 33 15H17ZM25 32C25 32 18.3594 34.3555 16.5 40H33.5312C31.6953 34.2422 25 32 25 32Z",
    fill: "#FFC542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/Pending.16569585e3428e22a83ee84821f4ca56.svg";
export { ForwardRef as ReactComponent };